/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  LabelValuePair,
  LabelValuePairFromJSON,
  LabelValuePairFromJSONTyped,
  LabelValuePairToJSON,
} from "./";

/**
 *
 * @export
 * @interface Package
 */
export interface Package {
  /**
   *
   * @type {string}
   * @memberof Package
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof Package
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof Package
   */
  helpText?: string | null;
  /**
   *
   * @type {Array<LabelValuePair>}
   * @memberof Package
   */
  children?: Array<LabelValuePair>;
  /**
   *
   * @type {boolean}
   * @memberof Package
   */
  fullWeek?: boolean;
  /**
   *
   * @type {number}
   * @memberof Package
   */
  id: number;
}

export function PackageFromJSON(json: any): Package {
  return PackageFromJSONTyped(json, false);
}

export function PackageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Package {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    label: json["label"],
    value: json["value"],
    helpText: !exists(json, "helpText") ? undefined : json["helpText"],
    children: !exists(json, "children")
      ? undefined
      : (json["children"] as Array<any>).map(LabelValuePairFromJSON),
    fullWeek: !exists(json, "fullWeek") ? undefined : json["fullWeek"],
    id: json["id"],
  };
}

export function PackageToJSON(value?: Package | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    label: value.label,
    value: value.value,
    helpText: value.helpText,
    children:
      value.children === undefined
        ? undefined
        : (value.children as Array<any>).map(LabelValuePairToJSON),
    fullWeek: value.fullWeek,
    id: value.id,
  };
}
